import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useEffect } from 'react';
import Navbar from '../components/Navbar';
import Hero from '../components/Hero';
import Benefits from '../components/Benefits';
import Categories from '../components/Categories';
import ProductGrid from '../components/ProductGrid';
import Packages from '../components/Packages';
import Footer from '../components/Footer';
import SEO from '../components/SEO';
import { productsAPI } from '../lib/api';
import { useLanguage } from '../lib/language';
export default function Home() {
    const { language } = useLanguage();
    const [products, setProducts] = useState([]);
    const [loading, setLoading] = useState(true);
    const [loadError, setLoadError] = useState(false);
    const [selectedCategory, setSelectedCategory] = useState('all');
    useEffect(() => {
        loadProducts();
    }, [selectedCategory]);
    const loadProducts = async () => {
        try {
            setLoading(true);
            setLoadError(false);
            const data = await productsAPI.getAll({
                category: selectedCategory === 'all' ? undefined : selectedCategory,
            });
            setProducts(data.products || []);
        }
        catch (error) {
            console.error('Failed to load products:', error);
            setLoadError(true);
            setProducts([]);
        }
        finally {
            setLoading(false);
        }
    };
    const seoTitle = language === 'es'
        ? 'Suplementos Naturales Premium para Salud y Bienestar'
        : 'Premium Natural Supplements for Health & Wellness';
    const seoDescription = language === 'es'
        ? 'Descubre nuestra línea completa de suplementos naturales respaldados por la ciencia para mejorar tu sueño, concentración, energía y bienestar general. Probados en laboratorio, sin aditivos artificiales. Envío gratis en pedidos superiores a $50.'
        : 'Discover our complete line of science-backed natural supplements to improve your sleep, focus, energy, and overall wellness. Lab-tested, no artificial additives. Free shipping on orders over $50.';
    const seoKeywords = language === 'es'
        ? ['suplementos naturales México', 'vitaminas naturales', 'suplementos para dormir', 'suplementos energía', 'minerales naturales', 'productos bienestar']
        : ['natural supplements Mexico', 'natural vitamins', 'sleep supplements', 'energy supplements', 'natural minerals', 'wellness products'];
    return (_jsxs("div", { className: "min-h-screen bg-white", children: [_jsx(SEO, { title: seoTitle, description: seoDescription, keywords: seoKeywords, url: "/", type: "website" }), _jsx(Navbar, {}), _jsx(Hero, {}), _jsx(Benefits, {}), _jsx(Categories, { selectedCategory: selectedCategory, onSelectCategory: setSelectedCategory }), _jsx("section", { id: "shop", className: "py-20 bg-white", children: _jsxs("div", { className: "max-w-7xl mx-auto px-4 sm:px-6 lg:px-8", children: [_jsxs("div", { className: "text-center mb-12", children: [_jsx("h2", { className: "text-4xl font-bold text-gray-900 mb-4", children: selectedCategory === 'all' ? 'All Products' : `${selectedCategory} Supplements` }), _jsx("p", { className: "text-lg text-gray-600", children: "Premium natural supplements for your wellness journey" })] }), loading ? (_jsx("div", { className: "text-center py-12", children: _jsx("div", { className: "inline-block animate-spin rounded-full h-12 w-12 border-b-2 border-primary-600" }) })) : loadError ? (_jsxs("div", { className: "text-center py-12", children: [_jsx("p", { className: "text-gray-600 mb-4", children: language === 'es'
                                        ? 'No se pudieron cargar los productos. Por favor, intenta de nuevo.'
                                        : 'Could not load products. Please try again.' }), _jsx("button", { onClick: loadProducts, className: "px-6 py-2 bg-primary-600 text-white rounded-lg hover:bg-primary-700 transition-colors", children: language === 'es' ? 'Reintentar' : 'Retry' })] })) : (_jsx(ProductGrid, { products: products }))] }) }), _jsx(Packages, {}), _jsx(Footer, {})] }));
}
